import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white } from 'styles/colors'
import { title } from 'styles/texts'
import {
  consultantInterestsSelector,
  isSelfSelector,
  isAdminSelector,
} from 'selectors'

import TagList from 'components/TagList'
import EditModalButton from 'components/EditModalButton'
import EditInterests from 'components/EditInterests'

const Wrapper = styled.div`
  padding: 30px;
  margin-top: 8px;
  border-radius: 6px;
  background-color: ${white};
`

const Heading = styled.div`
  ${title};
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`

const Heart = styled.img`
  margin-right: 6px;
`

const Interests = ({ isSelf, isAdmin, interests, consultantId }) => (
  <Wrapper>
    <Heading>
      <Heart src="/icons/interest.svg" alt="" />
      <div>Interesser</div>
      {(isSelf || isAdmin) && (
        <EditModalButton
          title="Endre interesser"
          renderForm={props => (
            <EditInterests consultantId={consultantId} {...props} />
          )}
        />
      )}
    </Heading>
    <TagList tags={interests} />
  </Wrapper>
)

const mapStateToProps = (state, { consultantId }) => ({
  isSelf: isSelfSelector(state, consultantId),
  isAdmin: isAdminSelector(state),
  interests: consultantInterestsSelector(state, consultantId) || [],
})

export default connect(mapStateToProps)(Interests)



// WEBPACK FOOTER //
// ./src/components/Consultant/Interests.js